<template>
    <footer class="footer">
      <div class="footer-content">
        <div class="footer-section about">
          <h3>关于我们</h3>
          <p>我们是一家专注于全景展示和虚拟现实技术的公司，提供高质量的虚拟体验。</p>
        </div>
  
        <div class="footer-section links">
          <h3>快速链接</h3>
          <ul>
            <li><a href="#">首页</a></li>
            <li><a href="#">作品展示</a></li>
            <li><a href="#">联系我们</a></li>
          </ul>
        </div>
  
        <div class="footer-section contact">
          <h3>联系我们</h3>
          <p>地址: 浙江省杭州市</p>
          <p>电话: 123-456-7890</p>
          <p>邮箱: info@example.com</p>
        </div>
      </div>
  
      <div class="footer-bottom">
        &copy; 2024 全景展示 | 设计: 您的公司
      </div>
    </footer>
  </template>
  
  <script>
  export default {
    name: 'footerC',
  }
  </script>
  
  <style scoped>
  .footer {
    margin-top: 40px;
    background-color: #333;
    color: #fff;
    padding: 20px 0;
    text-align: center;
  }
  
  .footer-content {
    display: flex;
    justify-content: space-around;
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
  }
  
  .footer-section {
    flex: 1;
    padding: 10px;
  }
  
  .footer-section h3 {
    margin-bottom: 15px;
  }
  
  .footer-section p,
  .footer-section ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }
  
  .footer-section a {
    color: #fff;
    text-decoration: none;
    transition: color 0.3s ease;
  }
  
  .footer-section a:hover {
    color: #ffa500;
  }
  
  .footer-bottom {
    background-color: #222;
    padding: 10px 0;
    margin-top: 20px;
    font-size: 14px;
  }
  </style>
  